import AllWork from './AllWork'

const Work = () => (
    <div className='container' style={{'background': 'white'}}>
      <AllWork />
    </div>
)

export default Work